import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'

const coupleWrapperCss = css`
  background: ${colors.gray02};
  border-inline-end: 1px solid ${colors.gray10};
  border-start-start-radius: 8px;
  border-start-end-radius: 8px;
  border-end-start-radius: 8px;

  /* This removes the little trailing line used to connect the children section when we aren't showing it */
  &[data-hint] {
    border-end-end-radius: 8px;
  }
`

const coupleCss = css`
  background: ${colors.gray00};
  border-inline-start: 1px solid ${colors.gray10};
  border-bottom: 1px solid ${colors.gray10};
  border-top: 1px solid ${colors.gray10};
  border-radius: 8px;
  padding: 0 15px;

  & [data-hint] {
    background: ${colors.green03};
    border-start-start-radius: 8px;
    border-start-end-radius: 8px;
    color: ${colors.green90};
    margin: 0 1px;
    padding: 4px 12px;
    text-align: center;
    width: calc(100% - 2px);
  }
`

type Props = {
  children: ReactNode
  'data-hint'?: boolean
}
export default function CoupleWrapper({ children, ...props }: Props): JSX.Element {
  return (
    <div css={coupleWrapperCss} {...props}>
      <div css={coupleCss}>{children}</div>
    </div>
  )
}
